module.exports = __webpack_public_path__ + "images/navigation/juul-nora-b04fa47e.png";